"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frenchDROMCountryCodes = exports.frenchDepartments = exports.frenchDepartmentCodes = exports.frenchCOMCountryCodes = exports.countryCodes = exports.countries = void 0;
const countries_1 = require("./countries");
Object.defineProperty(exports, "countries", { enumerable: true, get: function () { return countries_1.countries; } });
const countryCodes_1 = require("./countryCodes");
Object.defineProperty(exports, "countryCodes", { enumerable: true, get: function () { return countryCodes_1.countryCodes; } });
const frenchDepartments_1 = require("./frenchDepartments");
Object.defineProperty(exports, "frenchDepartments", { enumerable: true, get: function () { return frenchDepartments_1.frenchDepartments; } });
const ISO_3166_1_alpha_2_frenchCOMCodes_1 = require("./ISO_3166_1_alpha_2_frenchCOMCodes");
Object.defineProperty(exports, "frenchCOMCountryCodes", { enumerable: true, get: function () { return ISO_3166_1_alpha_2_frenchCOMCodes_1.ISO_3166_1_alpha_2_frenchCOMCodes; } });
const ISO_3166_1_alpha_2_frenchDROMCodes_1 = require("./ISO_3166_1_alpha_2_frenchDROMCodes");
Object.defineProperty(exports, "frenchDROMCountryCodes", { enumerable: true, get: function () { return ISO_3166_1_alpha_2_frenchDROMCodes_1.ISO_3166_1_alpha_2_frenchDROMCodes; } });
/**
 * INSEE codes for French departments
 */
const frenchDepartmentCodes = Object.keys(frenchDepartments_1.frenchDepartments).sort();
exports.frenchDepartmentCodes = frenchDepartmentCodes;
